import view from "../../views/offscreen";
import KTAPI from "../api/index.api";
import KTDrawer from "../components/drawer";
import { router } from "../router/index.routes";
import { ioSocket, akrosSocket } from "../mm/index.mm";
import { KTLang } from "../lang/lang";

const isTokenExpired = (token) => {try{let a = Date.now() >= (JSON.parse(atob(token.split('.')[1]))).exp * 1000; return a;}catch(e){return true;}};

import { _user, _handler, PopoverProfileManager, WindowManager, animateCSS  } from "../classes/index.classes";
import KTCookie from "../components/cookie";

var chatSound = new Audio('assets/media/sounds/chat.mp3');
var friendRequestSound = new Audio('assets/media/sounds/friend-request.mp3');
var friendAcceptSound = new Audio('assets/media/sounds/friend-accept.mp3');

let offscreen = {
    render: () => {        
        return view;
    },
    after_render: async () => {
        //console.log("offscreen");
        if(!window.isMobile) renderAkrosApp();

        initProfilePopovers();

        if(!_user.authed)
        {  
           
        }
        else
        {
            /**
             * 
             * PARTY
             * 
             */

            //initPartyDrawer();

            /**
             * 
             * GLOBAL CHAT
             * 
             */
            if(router.getCurrentLocation().url.includes("livestream")){ 
                
                $(".app-global-chat").addClass("d-none");
            }

            startGlobalChat();


            /**
             * 
             * Friends
             * 
            */

            _user.friends = await KTAPI.getFriends({id: _user.me.communityid, paged: false});
            
            renderFriendList(_user.friends);
            let req = await KTAPI.getFriendRequests({});
            if(req.length)
            {
                $("#btn-friends").append(`<span id="badge-header-friends" class="position-absolute translate-middle badge badge-circle badge-primary badge-chat" style="width:1.55rem;height:1.55rem;top: 8px;right: -16px;">${req.length}</span>`);
            }



            let drawerEl = document.querySelector("#kt_friends");
            let modalEl = document.querySelector("#kt_friends_search");
            
            bootstrap.Modal.getOrCreateInstance(modalEl);
            await KTDrawer.init();

            let drawer = await KTDrawer.getInstance(drawerEl);
            //console.log(drawer);
            drawer.on("kt.drawer.show", async function() {
                //console.log("drawer.show"); 
                let requests = await KTAPI.getFriendRequests({});
                $("#friend-request-container").html("");
                if(requests.length > 0)
                {
                    if($("#friend-request-num").length)
                    {
                        $("#friend-request-num").text(requests.length);
                    }
                    else
                    {
                        $("#friend-request-tab").after(`<span id="friend-request-num" class="ms-2 badge bg-primary">${requests.length}<span>`);
                    }
                }
                renderRequestList(requests);
            });

            $("#kt_friends_search").off("show.bs.modal");
            $("#kt_friends_search").on("show.bs.modal", async function() {
                $(".suggestion-list").data("search-page",1);
                let page = 1;

                let suggestions = await KTAPI.getSuggestions({page});   
                $(".suggestion-list").data("search-total-results",suggestions.totalDocs || 0);
                $(".suggestion-list").data("search-total-pages",suggestions.totalPages || 0);
                $(".suggestion-list").data("search-has-next",suggestions.hasNextPage || 0);
                $(".suggestion-list").data("search-next-page",suggestions.nextPage || 0);

                $("#friends-steam-num").text(suggestions.totalDocs || 0);

                if($("#friend-steam-num").length)
                {
                    $("#friend-steam-num").text(suggestions.totalDocs || 0);
                }
                else
                {
                    $("#friend-steam-tab").after(`<span id="friend-steam-num" class="ms-2 badge  bg-primary">${suggestions.totalDocs || 0}</span>`);
                }

                //console.log(suggestions);  
                renderSuggestionList(suggestions.docs ? suggestions.docs : []);

                var loadingSuggestionList = false;

                $(".suggestion-list").off("scroll");
                $(".suggestion-list").on("scroll", async function() {
                    
                    if (($(this).scrollTop() + $(this).innerHeight()) >= $(this)[0].scrollHeight - 100) {                                                

                        if($(".suggestion-list").data("search-has-next") && !loadingSuggestionList)
                        {
                            loadingSuggestionList = true;
                            suggestions = await KTAPI.getSuggestions({page:$(".suggestion-list").data("search-next-page")});
                            $(".suggestion-list").data("search-page",suggestions.page);
                            $(".suggestion-list").data("search-has-next",suggestions.hasNextPage);
                            $(".suggestion-list").data("search-next-page",suggestions.nextPage);
                            renderSuggestionList(suggestions.docs);
                            loadingSuggestionList = false;
                        }
                        
                    }
                });

            });

            $("#kt_friends_search").off("hide.bs.modal");
            $("#kt_friends_search").on("hide.bs.modal", async function() {                

                $("#friend-search-num").remove();

                $("#friend-search-input").val('');
                $("#friends-result").addClass("d-none");
                $("#friends-empty").addClass("d-none");
                $("#friend-search-spinner").addClass("d-none");
                $("#friend-search-clear").addClass("d-none");


                $("#friend-steam-num").remove();
                $(".suggestion-list").html("");
            });


            $("#friend-search-form").submit(function(e){
                e.preventDefault(); 
            });
           
            $("#friend-search-input").on("input", async function(e){
                $("#friends-result").data("search-page",1);
                let page = 1;
                let pattern = $(this).val();
                if(pattern.length > 2)
                {    
                    $("#friend-search-clear").addClass("d-none"); 
                    $("#friend-search-spinner").removeClass("d-none");
                                        
                    let usersFound = await KTAPI.searchFriends({pattern,page});
                    $("#friends-result").data("search-total-results",usersFound.totalDocs);
                    $("#friends-result").data("search-total-pages",usersFound.totalPages);
                    $("#friends-result").data("search-has-next",usersFound.hasNextPage);
                    $("#friends-result").data("search-next-page",usersFound.nextPage);

                    $("#friends-result").html("");
                    if(usersFound.totalDocs)
                    {
                        if($("#friend-search-num").length)
                        {
                            $("#friend-search-num").text(usersFound.totalDocs);
                        }
                        else
                        {
                            $("#friend-search-tab").after(`<span id="friend-search-num" class="ms-2 badge  bg-primary">${usersFound.totalDocs}</span>`);
                        }
                        

                        $("#friends-empty").addClass("d-none");
                        $("#friends-result").removeClass("d-none");
                        renderResultList(usersFound.docs);
                        
                        $("#friend-search-spinner").addClass("d-none"); 
                        $("#friend-search-clear").removeClass("d-none"); 


                        $("#friend-search-spinner").addClass("d-none");
                        $("#friend-search-clear").removeClass("d-none");
                        
                        var loadingFoundList = false;
                        $("#friends-result").off("scroll");
                        $("#friends-result").on("scroll", async function() {
                            if (($(this).scrollTop() + $(this).innerHeight()) >= $(this)[0].scrollHeight - 100) {
                                
                                if($("#friends-result").data("search-has-next") && !loadingFoundList)
                                {
                                    loadingFoundList = true;
                                    usersFound = await KTAPI.searchFriends({pattern,page:$("#friends-result").data("search-next-page")});
                                    $("#friends-result").data("search-page",usersFound.page);
                                    $("#friends-result").data("search-has-next",usersFound.hasNextPage);
                                    $("#friends-result").data("search-next-page",usersFound.nextPage);
                                    renderResultList(usersFound.docs);
                                    loadingFoundList = false;
                                }
                                
                            }
                        });
                    }
                    else
                    {

                        $("#friend-search-num").remove();

                        $("#friend-search-spinner").addClass("d-none"); 
                        $("#friend-search-clear").removeClass("d-none"); 

                        $("#friends-result").addClass("d-none");
                        $("#friends-empty").removeClass("d-none");
                    }
                    
                }
                else
                {                    
                    //$("#friends-result").addClass("d-none");
                    //$("#friends-empty").addClass("d-none");
                }
                if(!pattern.length)
                {
                    $("#friend-search-num").remove();

                    $("#friends-result").addClass("d-none");
                    $("#friends-empty").addClass("d-none");
                    $("#friend-search-spinner").addClass("d-none");
                    $("#friend-search-clear").addClass("d-none");
                }
            });

            $("#friend-search-clear").on("click", function(){

                $("#friend-search-num").remove();

                $("#friend-search-input").val('');
                $("#friends-result").addClass("d-none");
                $("#friends-empty").addClass("d-none");
                $("#friend-search-spinner").addClass("d-none");
                $("#friend-search-clear").addClass("d-none");

                $("#friend-search-input").trigger("focus");
            });


            $("#friend-list-search-input").on("input", async function(e){
                if($(this).val().length > 0)
                {
                    $("#friend-list-container").addClass("d-none");                    
                    $("#friend-list-search-clear").removeClass("d-none");
                    //let filtered = KTAPI.user.friends.filter(friend => friend.nickname.toLowerCase().includes($(this).val()));
                    let filtered = _user.friends.filter(friend => friend.nickname.toLowerCase().includes($(this).val()));
                    $("#friend-filter-container").html("");
                    renderFriendFilterList(filtered);
                    $("#friend-filter-container").removeClass("d-none");

                }
                else{
                    $("#friend-list-search-clear").addClass("d-none");
                    $("#friend-filter-container").addClass("d-none").html("");
                    $("#friend-list-container").removeClass("d-none");
                }
            });

            $("#friend-list-search-clear").on("click", function(){
                $("#friend-list-search-clear").addClass("d-none");
                $("#friend-filter-container").addClass("d-none").html("");
                $("#friend-list-container").removeClass("d-none");
                $("#friend-list-search-input").val('');

                $("#friend-list-search-input").trigger("focus");
            });

            ioSocket.socket.on('user-connected', async (data) => {

                $(`.friend-user[data-commid=${data.data.communityid}]`).removeClass("opacity-50");
                $(`.friend-user[data-commid=${data.data.communityid}]`).find(".online-badge").removeClass("bg-gray-400").addClass("bg-success");
                $(`.friend-user[data-commid=${data.data.communityid}]`).find(".chat-msg-btn").html(`<i class="bi bi-chat-left-dots-fill fs-5"></i>`);
                $(`.friend-user[data-commid=${data.data.communityid}]`).appendTo($("#friend-online-list"));
                $("#friend-online-num").text(parseInt($("#friend-online-num").text())+1);
                $("#friend-offline-num").text(parseInt($("#friend-offline-num").text())-1);

            });

            ioSocket.socket.on('user-disconnected', async (data) => {
                $(`.friend-user[data-commid=${data.data.communityid}]`).addClass("opacity-50");
                $(`.friend-user[data-commid=${data.data.communityid}]`).find(".online-badge").removeClass("bg-success").addClass("bg-gray-400");
                $(`.friend-user[data-commid=${data.data.communityid}]`).find(".chat-msg-btn").html(`<i class="bi bi-envelope-fill fs-5"></i>`);
                $(`.friend-user[data-commid=${data.data.communityid}]`).appendTo($("#friend-offline-list"));
                $("#friend-online-num").text(parseInt($("#friend-online-num").text())-1);
                $("#friend-offline-num").text(parseInt($("#friend-offline-num").text())+1);
            });

            ioSocket.socket.on("friend-request-recv", async (data) => {
                console.log("friend req recv from ", data.sender);
                renderRequestList([data.sender]);

                if($("#badge-header-friends").length)
                {
                    $("#btn-friends").text(parseInt($("#btn-friends").text())+1);
                }
                else
                {
                    $("#btn-friends").append(`<span id="badge-header-friends" class="position-absolute translate-middle badge badge-circle badge-primary badge-chat" style="width:1.55rem;height:1.55rem;top: 8px;right: -16px;">1</span>`);
                }

                friendRequestSound.play();
                
            });

            ioSocket.socket.on("friend-accept-recv", async (data) => {
                console.log("friend accept recv from ", data.accepter);
                renderFriendList([data.accepter], false);                

                friendAcceptSound.play();
                
            });


            /**
             * 
             *  CHAT
             * 
            */
            const localstamp = Math.floor(Date.now() / 1000);
            let chats = await KTAPI.getMessages({paged: true, limit: 15});
            

            if(chats.message == 'done')
            {
                hostStampDif = localstamp - chats.hostStamp;
                if(chats.res.docs){
                    $("#chat-list-container").data("chat-list-page", chats.res.page);
                    $("#chat-list-container").data("chat-list-has-next", chats.res.hasNextPage);
                    $("#chat-list-container").data("chat-list-next-page", chats.res.nextPage);
                    _user.chats = chats.res.docs;
                }
                else
                {
                    _user.chats = chats.res;
                    
                }
                
            }
            
            renderChatList(_user.chats);

            var loadingChatList = false;
            $("#chat-list-container").off("scroll");
            $("#chat-list-container").on("scroll", async function() {
                
                if (($(this).scrollTop() + $(this).innerHeight()) >= $(this)[0].scrollHeight - 100) {
                   
                    if($("#chat-list-container").data("chat-list-has-next") && !loadingChatList)
                    {
                        loadingChatList = true;
                        
                        chats = await KTAPI.getMessages({paged: true, page:$("#chat-list-container").data("chat-list-next-page"),limit: 15});
                        $("#chat-list-container").data("chat-list-page", chats.res.page);
                        $("#chat-list-container").data("chat-list-has-next", chats.res.hasNextPage);
                        $("#chat-list-container").data("chat-list-next-page", chats.res.nextPage);
                        _user.chats.push(...chats.res.docs);
                        renderChatList(chats.res.docs);

                        loadingChatList = false;
                    }
                    
                }
            });
            

            

            $('span.chat-pill[data-bs-toggle=pill]').off('shown.bs.tab');
            $('span.chat-pill[data-bs-toggle=pill]').on('shown.bs.tab', function (e) {
                let target = $(e.target).attr("href") // activated tab                                                
                var element = document.getElementById($(`${target} [data-kt-scroll=true]`).attr("id"));
                var scroll = KTScroll.getInstance(element);
                scroll.update();
                KTMenu.createInstances();
            });

            $("#kt_chat").on("click",".chat-with", async (e) => {
                _user.viewingChat = true;
                $(`span[href="#chat-with-box"]`).tab("show");
                setTimeout(() => {
                    $(".chat-with-text").trigger("focus");
                }, 200);
                
                let target = $(e.target).parents();
                let el = null;
                if($(target.prevObject).attr("id") && $(target.prevObject).attr("id").includes("chat-contact"))
                {
                    el = $(e.target);
                }
                else
                {                    

                    Object.keys(target).map(function(key, index) {
                        let par = target[key];
                        if($(par).attr("id") && $(par).attr("id").includes("chat-contact"))
                        {
                            el = $(par);
                        }
                    });
                }
                

                renderChatBox(el.data("thread"));
                renderChatContent(el.data("thread"));
            });

            $("#kt_chat").on("click",".chat-back", async () => {
                //console.log("back");
                _user.viewingChat = false;
                if($("#chat-with-send").data("info")._id !== undefined) //existe el thread
                {if($("#chat-with-send").data("info") !== undefined) ioSocket.socket.emit("chat-lastseen",{thread: $("#chat-with-send").data("info"), who: _user.me._id});}
                $(`span[href="#chat-list-box"]`).tab("show");
            });

            let dwChat = document.querySelector("#kt_chat");
            let dw = KTDrawer.getInstance(dwChat);
            dw.on("kt.drawer.show", async function() {
                if($("#chat-with-box").hasClass("show") && $("#chat-with-box").hasClass("active")) //si esta abierto un chat
                {
                    if($("#chat-with-send").data("info")._id !== undefined)
                    {
                        let chat = {_id: $("#chat-with-send").data("info")._id}
                        if($(`#chat-contact-${chat._id}`).length)
                        {
                            //notificacion header chat
                            if($(`#chat-contact-${chat._id}`).find(".badge").length)
                            {
                                if(parseInt($("#badge-header-chats").text()) == 1)
                                {
                                    $("#badge-header-chats").remove();
                                    
                                }
                                else
                                {
                                    $("#badge-header-chats").text(parseInt($("#badge-header-chats").text())-1);
                                }
                            }

                            //notificacion local
                            $(`#chat-contact-${chat._id}`).find(".badge").remove();
                            
                        }

                    }
                    
                }
            });


            const sendChatText = async () =>
            {
                let content = $(".chat-with-text").val().encodeHTML();
                if(!content.length) return;
                $(".chat-with-text").val("");
                
                let what = $("#chat-with-send").data("info");
                let uuid = uuidv4();
                
                $("#chat-with-container").append(renderChatMessage({
                    sentby: _user.me._id,
                    message: content,
                    _id: "temp-"+ uuid,
                    temp: true,
                    started: Math.floor(Date.now() / 1000),
                }));

                $("#chat-with-container").scrollTop(function() { return this.scrollHeight; });

                if(ioSocket.connected){             
                    //console.log("socket can chat");
                    if(ioSocket.socket != null)
                    {
                        //console.log("sending chat");                                                    
                        ioSocket.socket.emit('chat-send', {to:what.members, content, tempid: uuid, thread: what._id});
                        
                    }
                }
            }

            $(".chat-with-text").on("keypress", async (e) => {
                if (e.keyCode == 27)
                {
                    e.preventDefault();
                }

                if (e.keyCode == 13 && !e.shiftKey) {
                    e.preventDefault();
                    sendChatText();                    
                }
            });

            $("#chat-with-send").on("click", async (e) => {                
                
                sendChatText();
            });



            ioSocket.socket.on('chat', async (data) => {
                //console.log("new chat arrived");
                //console.log(data.chat);
                if(data.message == 'sent')
                {
                    //if(data.chat.justCreated)
                    //{
                        let fnd = false;
                        let thisThread = -1;
                        for (let index = 0; index < _user.chats.length; index++) {
                            let chat = _user.chats[index];
                            
                            if(chat._id === data.chat.thread)
                            {                                                                
                                fnd = true;
                                thisThread = index;
                                break;
                            }
                        }
                        if (thisThread > -1) {
                            _user.chats[thisThread].messages.push({
                                createdAt: data.chat.createdAt,
                                message: data.chat.message,
                                sender: [data.chat.sender[0]],
                                sentby: data.chat.sentby,
                                started: data.chat.started,
                                updatedAt: data.chat.updatedAt,
                                _id: data.chat._id
                            });
                        }
                        else
                        {
                            _user.chats.push(data.chat.thread_info);
                            thisThread = _user.chats.length - 1;
                            _user.chats[thisThread].messages = [];
                            _user.chats[thisThread].messages.push({
                                createdAt: data.chat.createdAt,
                                message: data.chat.message,
                                sender: [data.chat.sender[0]],
                                sentby: data.chat.sentby,
                                started: data.chat.started,
                                updatedAt: data.chat.updatedAt,
                                _id: data.chat._id
                            });
                            _user.chats[thisThread].members = [];
                            if(data.chat.sentby == _user.me._id)
                            {_user.chats[thisThread].members.push(data.chat.recipient[0]);}
                            else
                            {_user.chats[thisThread].members.push(data.chat.sender[0])}
                            
                        }
                                            
                        if(!$("#chat-contact-"+data.chat.thread).length)
                        {
                            renderChatList([_user.chats[thisThread]]);
                        }

                        if($("#chat-with-send").data("info") !== undefined && $("#chat-with-send").data("info")._id === undefined)
                        {
                            $("#chat-with-send").data("info", _user.chats[thisThread]);
                        }

                    //}

                    if(data.chat.sentby == _user.me._id)
                    {                        
                        if(data.chat.tempid)
                        {
                            //console.log("fixing sent");
                            $("#chat-msg-temp-"+data.chat.tempid).find(".timestamp").attr("data-i18n-options",`{'timestamp':'${parseInt(data.chat.started)+hostStampDif}'}`);
                            $("#chat-msg-temp-"+data.chat.tempid).localize();
                            $("#chat-msg-temp-"+data.chat.tempid).data("info", data.chat);
                            $("#chat-msg-temp-"+data.chat.tempid).removeClass("opacity-50");
                            $("#chat-msg-temp-"+data.chat.tempid).attr("id", `chat-msg-${data.chat._id}`);
                        }
                    }
                    else
                    {
                        //console.log("rendering not mine received", data.chat);
                        if($("#chat-with-send").data("info") !== undefined && $("#chat-with-send").data("info")._id === data.chat.thread && _user.viewingChat) //si el chat content esta open
                        {
                            //console.log("chat is open");
                            $("#chat-with-container").append(renderChatMessage(data.chat));
                            $("#chat-with-container").scrollTop(function() { return this.scrollHeight; });

                            //si esta cerrado el drawer hay que notificar pero esta activo el chat
                            if(!$("#kt_chat").hasClass("drawer-on") && $("#chat-with-box").hasClass("show") && $("#chat-with-box").hasClass("active"))
                            {
                                //console.log("drawer is closed");
                                //notificacion de chat
                                if($("#badge-header-chats").length)
                                {
                                    $("#badge-header-chats").text(parseInt($("#badge-header-chats").text())+1);
                                }
                                else
                                {
                                    $("#btn-chat").append(`<span id="badge-header-chats" class="position-absolute translate-middle badge badge-circle badge-primary badge-chat" style="width:1.55rem;height:1.55rem;top: 8px;right: -16px;">1</span>`);            
                                }

                                 //agregar su notification local
                                if($(`#chat-contact-${data.chat.thread}`).find(".badge").length)
                                {
                                    $(`#chat-contact-${data.chat.thread}`).find(".badge").text(parseInt($(`#chat-contact-${data.chat.thread}`).find(".badge").text())+1);
                                }
                                else{
                                    $(`#chat-contact-timestamp-${data.chat.thread}`).after(`<span class="badge badge-sm badge-light-success">1</span>`);
                                }
                            }
                        }
                        else
                        {
                            //console.log("chat cerrado");
                            //agregar su notification local
                            if($(`#chat-contact-${data.chat.thread}`).find(".badge").length)
                            {
                                $(`#chat-contact-${data.chat.thread}`).find(".badge").text(parseInt($(`#chat-contact-${data.chat.thread}`).find(".badge").text())+1);
                            }
                            else{
                                $(`#chat-contact-timestamp-${data.chat.thread}`).after(`<span class="badge badge-sm badge-light-success">1</span>`);

                                //notificacion de chat
                                if($("#badge-header-chats").length)
                                {
                                    $("#badge-header-chats").text(parseInt($("#badge-header-chats").text())+1);
                                }
                                else
                                {
                                    $("#btn-chat").append(`<span id="badge-header-chats" class="position-absolute translate-middle badge badge-circle badge-primary badge-chat" style="width:1.55rem;height:1.55rem;top: 8px;right: -16px;">1</span>`);            
                                }
                            }
                            
                            

                        }                        
                        chatSound.play();                        
                    }
                                                            
                    

                    setTimeout(() => {
                       $(`#chat-contact-timestamp-${data.chat.thread}`).text(moment.unix(parseInt(data.chat.started)+hostStampDif).locale(localStorage.getItem("i18nextLng")).format("h:mm a")); 
                    }, 300);                    
                    $("#chat-contact-"+data.chat.thread).find(".chat-last-message").text(data.chat.message.decodeHTML());
                    $("#chat-contact-"+data.chat.thread).prependTo("#chat-list-container");                                                        
                    $("#chat-contact-"+data.chat.thread).localize();
                }
            });

            ioSocket.socket.on('chat-is-active', async (data) => {
                if($("#chat-with-send").data("info") !== undefined && $("#chat-with-send").data("info").members[0].steamid === data.steamid)
                {
                    if(data.active)
                    {
                        $("#chat-active-indicator").html(`<span class="badge badge-success badge-circle w-10px h-10px me-1"></span>
                                            <span class="fs-8 fw-bold text-muted">Online</span>`);
                    }
                    else
                    {
                        $("#chat-active-indicator").html(`<span class="badge badge-dark badge-circle w-10px h-10px me-1"></span>
                                            <span class="fs-8 fw-bold text-muted">Offline</span>`);
                    }
                }
            });
            
            ioSocket.socket.on('contact-is-active', async (data) => {
                
                if($(`#chat-contact-${data.thread}`).length)
                {
                    
                    if(data.active)
                    {
                        $(`#chat-contact-${data.thread}`).find(".contact-online-indicator").addClass("bg-success").removeClass("bg-gray-400");
                    }
                    else
                    {
                        $(`#chat-contact-${data.thread}`).find(".contact-online-indicator").addClass("bg-gray-400").removeClass("bg-success");
                    }
                }
            });

            ioSocket.socket.on('user-connected', async (data) => {

                //chat en vivo
                if($("#chat-with-send").data("info") !== undefined && $("#chat-with-send").data("info").members[0].steamid === data.data.steamid)
                {
                    $("#chat-active-indicator").html(`<span class="badge badge-success badge-circle w-10px h-10px me-1"></span>
                                            <span class="fs-8 fw-bold text-muted">Online</span>`);
                }

                //lista
                _user.chats.map(chat => {
                    if($(`#chat-contact-${chat._id}`).length)
                    {
                        
                        if(chat.members[0].steamid === data.data.steamid)
                        {
                            $(`#chat-contact-${chat._id}`).find(".contact-online-indicator").addClass("bg-success").removeClass("bg-gray-400");
                        }
                    }
                });

            });

            ioSocket.socket.on('user-disconnected', async (data) => {
                
                 //chat en vivo
                if($("#chat-with-send").data("info") !== undefined &&  $("#chat-with-send").data("info").members[0].steamid === data.data.steamid)
                {
                    $("#chat-active-indicator").html(`<span class="badge badge-dark badge-circle w-10px h-10px me-1"></span>
                                            <span class="fs-8 fw-bold text-muted">Offline</span>`);
                }

                //lista
                _user.chats.map(chat => {
                    if($(`#chat-contact-${chat._id}`).length)
                    {
                        
                        if(chat.members[0].steamid === data.data.steamid)
                        {
                            $(`#chat-contact-${chat._id}`).find(".contact-online-indicator").addClass("bg-gray-400").removeClass("bg-success");
                        }
                    }
                });

            });
            

        }

        

        KTScroll.init();

    },
    root: false, 
    rerender: false,
    rendered: false,
    where: '#kt_offscreen',
};


$(document).ready(function(){
    
    $(document).on("click", ".friend-add",async function() {
        const token = KTCookie.get("token");                
        if(token && !isTokenExpired(token)) 
        {  
           let friendid = $(this).data("commid");
           let back = $(this).html();
           $(`.friend-add[data-commid=${friendid}]`).html(`<span class="spinner-border spinner-border-sm text-primary"></span> Processing...`).attr("disabled","true");
           let res = await KTAPI.addFriend({friendid});
           if(res.message == 'Added')
           {
            $(`.friend-add[data-commid=${friendid}]`).replaceWith(`<button class="btn btn-sm btn-outline btn-outline-dashed btn-outline-dark btn-active-light-dark py-2 px-4 fs-8 fs-bolder text-dark cursor-default" style="cursor:default !important">Requested</button>`).removeAttr("disabled");
           }
           else{
            $(`.friend-add[data-commid=${friendid}]`).html(back).removeAttr("disabled");
           }
        }
    });

    $(document).on("click", ".friend-accept", async function () {
        const token = KTCookie.get("token");
        if (token && !isTokenExpired(token)) {
            let friendid = $(this).data("commid");
            let back = $(`.friend-add[data-commid=${friendid}]`).html();
            
            $(`.friend-accept[data-commid=${friendid}]`).html(`<span class="spinner-border spinner-border-sm text-success"></span> Processing...`).attr("disabled", "true");
            $(`.friend-add[data-commid=${friendid}]`).html(`<span class="spinner-border spinner-border-sm text-primary"></span> Processing...`).attr("disabled","true");


            let res = await KTAPI.acceptFriend({
                requesterid: friendid
            });
            if (res.message == 'Accepted') {

                $(`.request-user[data-commid=${friendid}]`).fadeOut(300, function(){
                    $(this).remove();
                    $(`.separator[data-commid=${friendid}]`).remove();
                });
                _user.friends.push(res.friend);                
                renderFriendList([res.friend], false);
                toastr.info("Friend accepted");

                $(`.friend-add[data-commid=${friendid}]`).replaceWith(`<button class="btn btn-sm btn-outline btn-outline-dashed btn-outline-success btn-active-light-success py-2 px-4 fs-8 fs-bolder text-success cursor-default" style="cursor:default !important">Friends</button>`).removeAttr("disabled");

                let n = parseInt($("#friend-request-num").text()) - 1;
                if(n)
                {
                    $("#friend-request-num").text(n);
                }
                else
                {
                    $("#friend-request-num").remove();
                }

                //notif
                if($("#badge-header-friends").length)
                {
                    let n = parseInt($("#badge-header-friends").text());
                    if(n-1 == 0)
                    {
                        $("#badge-header-friends").remove();
                    }
                    if(n > 0)
                    {
                        $("#badge-header-friends").text(n-1);
                    }
                }

            } else {
                $(`.friend-add[data-commid=${friendid}]`).html(back).removeAttr("disabled");
            }
        }
    });

    $(document).on("click", ".friend-reject", async function () {
        const token = KTCookie.get("token");
        if (token && !isTokenExpired(token)) {
            let friendid = $(this).data("commid");
            let back = $(`.friend-pending[data-commid=${friendid}]`).html();
            
            $(`.friend-reject[data-commid=${friendid}]`).html(`<span class="spinner-border spinner-border-sm text-danger"></span> Processing...`).attr("disabled", "true");
            $(`.friend-pending[data-commid=${friendid}]`).html(`<span class="spinner-border spinner-border-sm text-primary"></span> Processing...`).attr("disabled","true");


            let res = await KTAPI.rejectFriend({
                requesterid: friendid
            });
            if (res.message == 'Rejected') {

                $(`.request-user[data-commid=${friendid}]`).fadeOut(300, function(){
                    $(this).remove();
                    $(`.separator[data-commid=${friendid}]`).remove();
                });
                //KTAPI.user.friends.push(res.friend);                
                //renderFriendList([res.friend], false);
                toastr.error("Request rejected");

                $(`.friend-pending[data-commid=${friendid}]`).replaceWith(`<button class="btn btn-sm btn-outline btn-outline-dashed btn-outline-primary btn-active-light-primary py-2 px-4 fs-8 fs-bolder text-primary friend-add" data-commid="${friendid}">Send Request</button>`).removeAttr("disabled");

                let n = parseInt($("#friend-request-num").text()) - 1;
                if(n)
                {
                    $("#friend-request-num").text(n);
                }
                else
                {
                    $("#friend-request-num").remove();
                }


                //notif
                if($("#badge-header-friends").length)
                {
                    let n = parseInt($("#badge-header-friends").text());
                    if(n-1 == 0)
                    {
                        $("#badge-header-friends").remove();
                    }
                    if(n > 0)
                    {
                        $("#badge-header-friends").text(n-1);
                    }
                }

            } else {
                $(`.friend-pending[data-commid=${friendid}]`).html(back).removeAttr("disabled");
            }
        }
    });

    $(document).on("mouseenter", ".friend-user",async function() { 
        let friendid = $(this).data("commid");
        $(".friend-user[data-commid="+friendid+"] button.chat-msg-btn").removeClass("d-none");
        
    });

    $(document).on("mouseleave", ".friend-user",async function() { 
        let friendid = $(this).data("commid");
        $(".friend-user[data-commid="+friendid+"] button.chat-msg-btn").addClass("d-none");
    });

    $(document).on("click", ".chat-msg-btn", async function () {
        let restore = $(this).html();
        $(this).html(`<span class="spinner-border spinner-border-sm text-white"></span>`);

        let data = $(this).data("info");

        const check = await KTAPI.checkThread({who:data._id});
        $(this).html(restore);
        if(check.message == 'error') return;

        let adata = {members: [data]};

        if(check.res.exist)
        {
            data = check.res.thread;
            data.members = adata.members;
        }    
        else
        {
            data = {members: [data]};
        }
        renderChatBox(data);
        renderChatContent(data);
        
        let drawerFriends = document.querySelector("#kt_friends");
        let drawer = KTDrawer.getInstance(drawerFriends);
        //drawer.hide();

        let drawerChat = document.querySelector("#kt_chat");
        drawer = KTDrawer.getInstance(drawerChat);
        drawer.show();
        
        $(`span[href="#chat-with-box"]`).tab("show");
        router.updatePageLinks();

        setTimeout(() => {
            $(".chat-with-text").trigger("focus");    
        }, 202);
        
        
    });


    $(document).on("keydown", async (e) => {        
        
        if ( e.keyCode === 27 && !$(".modal-backdrop.fade.show").length)
        {
            if($("#kt_chat").hasClass("drawer-on") && $("#chat-with-box").hasClass("show") && $("#chat-with-box").hasClass("active") /*&& !$(".chat-with-text").is(":focus")*/)
            {
                             
                _user.viewingChat = false;                
                e.preventDefault();
                $(".chat-back").trigger("click");
            }
            else if($("#kt_chat").hasClass("drawer-on") && $("#chat-list-box").hasClass("show") && $("#chat-list-box").hasClass("active") && !$("#chat-list-search-input").is(":focus") )
            {
                e.preventDefault();
                let drawerChat = document.querySelector("#kt_chat");
                let drawer = KTDrawer.getInstance(drawerChat);
                drawer.hide();
            }
            else if($("#kt_friends").hasClass("drawer-on") && !$("#kt_chat").hasClass("drawer-on")){
                e.preventDefault();
                let drawerChat = document.querySelector("#kt_friends");
                let drawer = KTDrawer.getInstance(drawerChat);
                //$("#kt_friends").removeClass("drawer-on");
                drawer.hide();
            }
        }
    });

    if(KTCookie.get('welcome') == null || KTCookie.get('welcome') === undefined || KTCookie.get('welcome') != 'true')
    {
        KTCookie.set('welcome', 'true', {expires: new Date(Date.now() + 100 * 365 * 24 * 60 * 60 * 1000)});
        welcomeDialog(function(){}, function(){});
    }

    $(document).on("click", "#btn-akros", async function () {
        akrosProcess();
    });
   
    

});

/**
 * 
 * PROFILE POPOVER 
 * 
 */


let profilePopoverInstance = null;

function initProfilePopovers()
{
    if(profilePopoverInstance == null) profilePopoverInstance = new PopoverProfileManager();    
}

/**
 * 
 * FRIENDS
 * 
 */

_handler.on('friends', (data) => {
    //renderFriendList(data);
});

export function renderFriendFilterList(data){
    let cont = [];
    if(data.length > 0){
        data.map(user => {
            cont.push(renderFriend(user));
        });
        $("#friend-filter-container").append(cont);
    }
    router.updatePageLinks();
}

export function renderFriendList(data,firsttime = true){
    let cons = [];
    let disc = [];
    if(data.length > 0){
        let con = 0, dis = 0;
        data.map(user => {
            user.connected ? cons.push(renderFriend(user)) : disc.push(renderFriend(user));
            user.connected ? con++ : dis++;
        });                

        if(firsttime){
            $("#friend-online-num").text(con).removeClass("d-none");
            $("#friend-offline-num").text(dis).removeClass("d-none")
        }else
        {
            $("#friend-online-num").text(parseInt($("#friend-online-num").text())+con);
            $("#friend-offline-num").text(parseInt($("#friend-offline-num").text())+dis);
        }

        $("#friend-online-list").append(cons);
        $("#friend-offline-list").append(disc);
    }
    router.updatePageLinks();
}

export function renderFriend(data){
    let conBadge = `<div class="symbol-badge online-badge bg-success start-100 top-100 border-1 border-black h-10px w-10px ms-n2 mt-n2"></div>`;
    let disconBadge = `<div class="symbol-badge online-badge bg-gray-400 start-100 top-100 border-1 border-black h-10px w-10px ms-n2 mt-n2"></div>`;
    let html = /*html*/ `
        <div class="d-flex flex-stack py-2 friend-user ${!data.connected ? 'opacity-50' : ''}" data-commid="${data.communityid}" >
            <!--begin::Details-->
            <div class="d-flex align-items-center">
                <!--begin::Avatar-->
                <div class="symbol symbol-40px">
                    <img alt="Pic" src="${data.avatar}">
                    ${data.connected ? conBadge : disconBadge}
                </div>
                <!--end::Avatar-->
                <!--begin::Details-->
                <div class="ms-5 mw-150px text-truncate text-nowrap">
                    <a href="user/${data.communityid}" data-navigo class="fs-7 fw-normal text-gray-900 mb-2 fnickname">${data.nickname}</a>
                    <!--<div class="fw-bold text-muted fs-7">${data.steamid}</div>-->
                </div>
                <!--end::Details-->
            </div>
            <!--end::Details-->
            <!--begin::Lat seen-->
            <div class="d-flex flex-column align-items-end ms-2">
                <!--<span class="text-muted fs-8 mb-1">2 weeks</span>-->
                <button class="d-none btn btn-sm btn-icon btn-light-info chat-msg-btn">
                    <i class="bi bi-${data.connected ? 'chat-left-dots-fill': 'envelope-fill'} fs-5"></i>
                </button>
            </div>
            <!--end::Lat seen-->
        </div>
    `;

    html = $(html);
    html.find(".chat-msg-btn").data("info", data);
    html.find(".fnickname").text(data.nickname);
    html.data("info", data);

    return html;
}

export function renderRequestList(data)
{
    let cont = [];
    if(data.length > 0){
        data.map(user => {
            cont.push(renderRequest(user));
        });
        $("#friend-request-container").append(cont);
    }
    router.updatePageLinks();
}

export function renderRequest(data)
{    

    let html = /* html */`<!--begin::User-->
    <div class="request-user my-4 pe-2" data-commid="${data.communityid}">
        <div class="d-flex text-dark align-items-center justify-content-between rounded mb-3">
            <!--begin::Symbol--> 
            <div class="d-flex justify-content-start">               
                <a href="user/${data.communityid}" data-navigo>
                    <div class="symbol symbol-40px me-4">
                        <img src="${data.avatar}" alt="">
                    </div>
                </a>                
                <!--end::Symbol-->
                <!--begin::Content-->
                <div class="d-flex flex-column justify-content-start fw-bold">
                    <a href="user/${data.communityid}" data-navigo class="fs-6 fw-bold text-gray-800 text-hover-primary mw-150px text-truncate text-nowrap fnickname">${data.nickname}</a>
                    <a href="https://steamcommunity.com/profiles/${data.communityid}/" target="_blank" class="fs-7 fw-bold text-gray-400 text-hover-gray-600"><!--<i class="fab fa-steam me-1"></i>-->${data.steamid}</a>
                </div>
            </div>
            <!--begin::Lat seen-->
            <div class="d-flex flex-column align-items-end ms-2">            
                <button class="btn btn-sm btn-icon btn-light-info chat-msg-btn">
                    <i class="bi bi-${data.connected ? 'chat-left-dots-fill': 'envelope-fill'} fs-5"></i>
                </button>
            </div>
            <!--end::Lat seen-->  
            <!--end::Content-->
        </div>
        <div class="d-flex text-dark align-items-center justify-content-between rounded">
            <div class="d-flex col-5">
                <button type="button" class="btn btn-sm btn-outline-success fw-bolder friend-accept w-100 text-truncate text-nowrap" data-commid="${data.communityid}"><i class="bi bi-check-lg"></i>Accept</button>
            </div>
            <div class="d-flex col-5">
                <button type="button" class="btn btn-sm btn-outline-danger fw-bolder friend-reject w-100 text-truncate text-nowrap" data-commid="${data.communityid}"><i class="bi bi-x-lg"></i>Reject</button>
            </div>
        </div>
    </div>
    <!--end::User-->
    <div class="separator separator-dashed" data-commid="${data.communityid}"></div>`;

    html = $(html);
    html.find(".chat-msg-btn").data("info", data);
    html.find(".fnickname").text(data.nickname);
    html.data("info", data);

    return html;
}


export function renderSuggestionList(data){
    let cont = "";
    if(data.length > 0){
        data.map(user => {
            cont+= renderUser(user);
        });
        $(".suggestion-list").append(cont);
    }
    router.updatePageLinks();
}

export function renderResultList(data){
    let cont = "";
    if(data.length > 0){
        data.map(user => {
            cont+= renderUser(user);
        });
        $("#friends-result").append(cont);
    }
    router.updatePageLinks();
}

export function renderUser(data){
    
    let btn = ``;
    if(data.friendsStatus == 0)
    {
        btn = `<button class="btn btn-sm btn-outline btn-outline-dashed btn-outline-primary btn-active-light-primary py-2 px-4 fs-8 fs-bolder text-primary friend-add" data-commid="${data.communityid}">Send Request</button>`;
    }
    if(data.friendsStatus == 1)
    {
        
        btn = `<button class="btn btn-sm btn-outline btn-outline-dashed btn-outline-info btn-active-light-info py-2 px-4 fs-8 fs-bolder text-info cursor-default friend-pending" style="cursor:default !important">Pending</button>`;
    }
    if(data.friendsStatus == 2)
    {
        btn = `<button class="btn btn-sm btn-outline btn-outline-dashed btn-outline-dark btn-active-light-dark py-2 px-4 fs-8 fs-bolder text-dark cursor-default friend-requested"  style="cursor:default !important">Requested</button>`;
    }
    if(data.friendsStatus == 3)
    {
        btn = `<button class="btn btn-sm btn-outline btn-outline-dashed btn-outline-success btn-active-light-success py-2 px-4 fs-8 fs-bolder text-success cursor-default friend-friend" style="cursor:default !important">Friends</button>`;
    }

    let html = `<!--begin::User-->
    <div class="d-flex text-dark align-items-center justify-content-between mb-5 rounded pe-2">
        <!--begin::Symbol--> 
        <div class="d-flex justify-content-start">               
            <a href="user/${data.communityid}" data-navigo>
                <div class="symbol symbol-40px me-4">
                    <img src="${data.avatar}" alt="">
                </div>
            </a>                
            <!--end::Symbol-->
            <!--begin::Content-->
            <div class="d-flex flex-column justify-content-start fw-bold">
                <a href="user/${data.communityid}" data-navigo class="fs-6 fw-bold text-gray-800 text-hover-primary mw-150px text-truncate text-nowrap">${sanitizeHTML(data.nickname)}</a>
                <a href="https://steamcommunity.com/profiles/${data.communityid}/" target="_blank" class="fs-7 fw-bold text-gray-400 text-hover-gray-600"><!--<i class="fab fa-steam me-1"></i>-->${data.steamid}</a>
            </div>
        </div>
        <div class="d-flex justify-content-end">
            ${btn}
        </div>
        <!--end::Content-->
    </div>
    <!--end::User-->`;
    return html;
}

/**
 * 
 * CHAT
 */

_handler.on("create-chats", (data) =>{
    //console.log("create-chats called");
    //renderChatList(data);
});

export const renderChatList = (data) => {
    if(data != null && data.length)
    {
        $("#chat-list-empty").addClass("d-none");
        $("#chat-list-container").removeClass("d-none");
        

        let list = [];
        data.map( thread =>{
            list.push(renderChatContact(thread));
        })

        $("#chat-list-container").append(list);

        //KTLang.update();
    }
    else{
        $("#chat-list-container").addClass("d-none");
        $("#chat-list-empty").removeClass("d-none");
    }
    
}

export const renderChatContact = (data) =>{

    //console.log(data);
    let news = 0;
    data.messages.map(msg => {
        if(data.lastseenby)
        {
            //console.log(data.lastseenby);
            if(data.lastseenby[_user.me._id] == undefined)
            {
                news++;
            }
            else
            {
                //console.log(msg.started, data.lastseenby[_user.me._id]);
                if(parseInt(msg.started)+hostStampDif > parseInt(data.lastseenby[_user.me._id])+hostStampDif) news++;
            }
        }
        else
        {
            news++;
        }
        
    });
    
    let html = /* html */ `<!--begin::Contact-->
    <div class="d-flex flex-stack py-4 px-9 cursor-pointer bg-state-white bg-state-opacity-5 chat-with" id="chat-contact-${data._id}">
        <!--begin::Details-->
        <div class="d-flex align-items-center">
            <!--begin::Avatar-->
            <div class="symbol symbol-45px">
                <img alt="Pic" src="${data.members[0].avatar}">
                <div class="symbol-badge online-badge bg-gray-400 start-100 top-100 border-1 border-black h-10px w-10px ms-n2 mt-n2 contact-online-indicator"></div>                
            </div>
            <!--end::Avatar-->
            <!--begin::Details-->
            <div class="ms-5 mw-150px w-150px text-truncate text-nowrap">
                <div href="user/${data.members[0].communityid}" class="fs-6 text-gray-900 mb-2 text-truncate text-nowrap fnickname"></div>
                <div class="fs-7 fw-bold text-muted text-truncate text-nowrap chat-last-message"></div>
            </div>
            <!--end::Details-->
        </div>
        <!--end::Details-->
        <!--begin::Lat seen-->
        <div class="d-flex flex-column align-items-end ms-2">
            <span id="chat-contact-timestamp-${data._id}" class="text-muted fs-7 mb-1" data-i18n="example.date" data-i18n-options='{"timestamp":"${parseInt(data.updated)+hostStampDif}"}'></span>
            ${ news ? `<span class="badge badge-sm badge-light-success">${news}</span>` : ''}
        </div>
        <!--end::Lat seen-->
    </div>
    <!--end::Contact-->`;

    if(news)
    {
        
        if($("#badge-header-chats").length)
        {
            $("#badge-header-chats").text(parseInt($("#badge-header-chats").text())+1);
        }
        else
        {
            $("#btn-chat").append(`<span id="badge-header-chats" class="position-absolute translate-middle badge badge-circle badge-primary badge-chat" style="width:1.55rem;height:1.55rem;top: 8px;right: -16px;">1</span>`);            
        }
    }    

    html = $(html);
    html.find(".chat-last-message").text(`${data.messages.length ? data.messages[(data.messages.length-1)].message.decodeHTML() : ''}`);
    //html.data("info", data.members[0]);
    html.data("thread", data);
    html.find(".fnickname").text(data.members[0].nickname);

    html.localize();

    ioSocket.socket.emit("contact-is-active", {steamid: data.members[0].steamid, thread: data._id});

    return html;
}


export const renderChatBox = (data) => {    
    //console.log(data);
    if(data.members.length > 1){ //group

    }else //direct message
    {
        ioSocket.socket.emit("chat-is-active", {steamid: data.members[0].steamid});
        $(".chat-with-avatar").attr("src", data.members[0].avatar);
        $(".chat-with-nickname").text(data.members[0].nickname);
        $(".chat-with-profile-url").attr("href", `user/${data.members[0].communityid}`);        
        $("#chat-with-send").data("info", data);

    }

    
}

export const renderChatContent = async (data) => {
    
    $("#chat-with-container").html("");
    //console.log(data);

    if(data._id){
        
        for (let index = 0; index < _user.chats.length; index++) {
            
            const chat = _user.chats[index];
            if(chat._id == data._id)
            {
                let content = [];
                chat.messages.map((msg) =>{
                    content.push(renderChatMessage(msg));
                });
                $("#chat-with-container").append(content);
                setTimeout(() => {
                    $("#chat-with-container").scrollTop($("#chat-with-container")[0].scrollHeight);    
                }, 200);
                
                if($(`#chat-contact-${chat._id}`).length)
                {
                    //notificacion header chat
                    if($(`#chat-contact-${chat._id}`).find(".badge").length)
                    {
                        if(parseInt($("#badge-header-chats").text()) == 1)
                        {
                            $("#badge-header-chats").remove();
                            
                        }
                        else
                        {
                            $("#badge-header-chats").text(parseInt($("#badge-header-chats").text())-1);
                        }
                    }

                    //notificacion local
                    $(`#chat-contact-${chat._id}`).find(".badge").remove();
                    
                    
                    
                }
                break;
            }
            
        }
    }
    else
    {

    }
    
}

export const renderChatMessage = (chat) => {
    //console.log(chat);
    let me = false;
    if(chat.sentby == _user.me._id){
        me = true;
    }
    
    let html = /*html*/ `
        ${me ? `<!--begin::Chat-->
        <div class="d-flex justify-content-end mb-6 ${chat.temp ? 'opacity-50':''}" id="chat-msg-${chat._id}">
            <!--begin::Wrapper-->
            <div class="d-flex flex-column align-items-end">                                            
                <!--begin::Text-->
                <div class="p-5 rounded bg-light-success text-dark fw-bold mw-lg-400px text-end msg-text text-wrap text-break">
                    
                </div>
                <div class="message-footer text-end">
                    <span class="fs-8 text-muted timestamp" data-i18n="example.date" data-i18n-options='{"timestamp":"${parseInt(chat.started)+hostStampDif}"}'></span>
                </div>
                <!--end::Text-->
            </div>
            <div class="symbol symbol-35px ms-3">
                <img alt="Pic" src="${_user.me.avatar}">
            </div>
            <!--end::Wrapper-->
        </div>
        <!--end::Chat-->`:

        `<div class="d-flex justify-content-start mb-6" id="chat-msg-${chat._id}">
            <!--begin::Wrapper-->
            <div class="symbol symbol-35px me-3">
                <img alt="Pic" src="${chat.sender[0].avatar}">
            </div>                                        
            <div class="d-flex flex-column align-items-start">                                            
                <!--begin::Text-->
                <div class="p-5 rounded bg-light-dark text-dark fw-bold mw-lg-400px text-start msg-text text-wrap text-break">
                    
                </div>
                <div class="message-footer text-start">
                    <span class="fs-8 text-muted timestamp" data-i18n="example.date" data-i18n-options='{"timestamp":"${parseInt(chat.started)+hostStampDif}"}'></span>
                </div>
                <!--end::Text-->
            </div>            
            <!--end::Wrapper-->
        </div>`}
    `;

    html = $(html);
    html.find(".msg-text").text(`${chat.message.decodeHTML()}`);
    html.data("info", chat);
    html.localize();
    return html;
}



/**
 * 
 * ERROR
 * 
 */

const errorMsg = (data) => {
    $("#merror-title").text(data.title);
    $("#merror-content").text(data.content);    
    $("#kt_modal_error").modal("show");
}


String.prototype.encodeHTML = function () {        
    return this.replace(/[\u00A0-\u9999<>\&]/g, ((i) => `&#${i.charCodeAt(0)};`));      
};

String.prototype.decodeHTML = function () {    
    return this.replace(/&#(\d+);/g, ((match, dec) => `${String.fromCharCode(dec)}`));
};

function uuidv4() {
    return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
      (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
  }

function sanitizeHTML(html) {
const $temp = $("<div>");
$temp.html(html);
const sanitizedHTML = $temp.text();
return sanitizedHTML;
}



const msgDialog = (message, onAccept, onClose) => {
    // Crear un ID único para el modal
    let modalId = 'myModal' + Date.now();

    // Crear el HTML del modal
    let modalHtml = `
        <div class="modal fade" id="${modalId}" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Modal title</h5>
                        <button class="btn btn-icon btn-active-color-primary btn-close" data-bs-dismiss="modal"><span class="svg-icon svg-icon-gray-600 svg-icon-2qx m-0"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect opacity="0.3" x="2" y="2" width="20" height="20" rx="5" fill="currentColor"/><rect x="7" y="15.3137" width="12" height="2" rx="1" transform="rotate(-45 7 15.3137)" fill="currentColor"/><rect x="8.41422" y="7" width="12" height="2" rx="1" transform="rotate(45 8.41422 7)" fill="currentColor"/></svg></span></button>
                        
                    </div>
                    <div class="modal-body">
                        ${message}
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                        <button type="button" class="btn btn-primary">Accept</button>
                    </div>
                </div>
            </div>
        </div>`;

    // Agregar el modal al cuerpo del documento
    document.body.insertAdjacentHTML('beforeend', modalHtml);

    // Crear el modal
    let modal = new bootstrap.Modal(document.getElementById(modalId));

    // Manejar el evento de cierre del modal
    modal._element.addEventListener('hidden.bs.modal', function () {
        onClose();
        // Eliminar el modal del documento
        document.body.removeChild(document.getElementById(modalId));
    });

    // Manejar el evento de aceptación
    modal._element.querySelector('.btn-primary').addEventListener('click', function () {
        onAccept();
        modal.hide();
    });

    // Mostrar el modal
    modal.show();
}


const welcomeDialog = (onAccept, onClose) => {
    // Crear un ID único para el modal
    let modalId = 'myModal' + Date.now();

    // Crear el HTML del modal
    let modalHtml = `
        <div class="modal fade" data-bs-backdrop="static" data-bs-keyboard="false" id="${modalId}" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header border-0">
                        <h2 class="modal-title" data-i18n="[html]welcome.title">Welcome Back to the Action!<br/>Discover the New pDx<span class="text-primary">PLAY</span></h2>
                        <button disabled class="btn btn-icon btn-active-color-primary btn-close" data-bs-dismiss="modal"><span class="svg-icon svg-icon-gray-600 svg-icon-2qx m-0"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect opacity="0.3" x="2" y="2" width="20" height="20" rx="5" fill="currentColor"/><rect x="7" y="15.3137" width="12" height="2" rx="1" transform="rotate(-45 7 15.3137)" fill="currentColor"/><rect x="8.41422" y="7" width="12" height="2" rx="1" transform="rotate(45 8.41422 7)" fill="currentColor"/></svg></span></button>
                        
                    </div>
                    <div class="modal-body modal-body fs-5 fw-semibold text-gray-700" data-i18n="[html]welcome.body">
                        <p class="">We're excited to announce the return of pDxPLAY, the ultimate platform for competitive Counter Strike 1.6 players. After a strategic pause, we're back with an experience that will leave you breathless.</p><br>

                        <h4>Discover the Difference:</h4>
                        <div class="d-flex flex-column">
                            <li class="d-flex align-items-center py-2"><span class="bullet bg-primary align-self-start mt-3 me-3"></span> <div class="d-block">✨ <span class="fst-italic text-gray-800">Advanced Ranking System</span>: Our unique ranking system, based on modified Glicko2, evaluates your individual and team performance in each match, providing accurate and fair rankings skill based.</div></li>
                            <li class="d-flex align-items-center py-2"><span class="bullet bg-primary align-self-start mt-3 me-3"></span> <div class="d-block">🚀 <span class="fst-italic text-gray-800">Top-Performance Servers</span>: Experience lag-free matches on our high-end servers spanning across the Americas, from the USA to Argentina.</div></li>
                            <li class="d-flex align-items-center py-2"><span class="bullet bg-primary align-self-start mt-3 me-3"></span> <div class="d-block">📊 <span class="fst-italic text-gray-800">Real-time Statistics</span>: Dive into detailed real-time stats to analyze your gameplay and strategically improve.</div></li>
                            <li class="d-flex align-items-center py-2"><span class="bullet bg-primary align-self-start mt-3 me-3"></span> <div class="d-block">🛡️ <span class="fst-italic text-gray-800">Professional Anticheat</span>: Play with confidence thanks to our state-of-the-art anticheat system that maintains competitive integrity.</div></li>
                            <li class="d-flex align-items-center py-2"><span class="bullet bg-primary align-self-start mt-3 me-3"></span> <div class="d-block">🏆 <span class="fst-italic text-gray-800">Epic Tournaments</span>: Get ready to face the best in exciting tournaments and achieve glory.</div></li>
                        </div>
                        <br/>
                        <p>Play Now and Elevate Your Experience in Counter Strike 1.6!</p>
                    </div>
                    <div class="modal-footer border-0">                        
                        <button type="button" class="btn btn-light-primary btn-active-primary btn-active-color-gray-200 btn-agreed" data-i18n="welcome.agreed">Agreed</button>
                    </div>
                </div>
            </div>
        </div>`;

    // Agregar el modal al cuerpo del documento
    document.body.insertAdjacentHTML('beforeend', modalHtml);

    // Crear el modal
    let modal = new bootstrap.Modal(document.getElementById(modalId));

    // Manejar el evento de cierre del modal
    modal._element.addEventListener('hidden.bs.modal', function () {
        onClose();
        // Eliminar el modal del documento
        document.body.removeChild(document.getElementById(modalId));
        KTCookie.set("welcome", 'true', {expires: new Date(Date.now() + 100 * 365 * 24 * 60 * 60 * 1000)});
    });

    // Manejar el evento de aceptación
    modal._element.querySelector('.btn-agreed').addEventListener('click', function () {
        onAccept();
        modal.hide();
        KTCookie.set("welcome", 'true', {expires: new Date(Date.now() + 100 * 365 * 24 * 60 * 60 * 1000)});
    });

    // Mostrar el modal
    modal.show();
}



/**
 * 
 * 
 * AKROS
 * 
 */
let akrosInProcess = false;
let akrosInterval = null;
let akrosFirstRender = 0;
function akrosProcess()
{   
    if(akrosSocket.state == -1) return;    
    if(akrosSocket.isAkrosRunning) return;
    $("#akros-modal-processing").modal("show");
    setTimeout(() => {
        $("#akros-modal").modal("show");
        $("#akros-modal-processing").modal("hide");
    }, 750);
}

function renderAkrosApp()
{
    akrosInterval = setInterval(() => {
        //console.log(akrosSocket);
        if(akrosSocket.state > -1)
        {
            renderAkrosBtn();
            clearInterval(akrosInterval);
        }
    }, 100);
}

function renderAkrosBtn()
{
    if(akrosFirstRender == 0) akrosFirstRender++;
    let html =  "";

    if(akrosSocket.isAkrosRunning)
    {
        html = /*html*/`
        
            <button id="btn-akros" class="btn akros-running btn-light-success btn-sm btn-color-white btn-active-color-gray-200 border border-succes btn-fixed-top">
                <i class="bi bi-shield-check fs-3"></i>
                <span class="d-none d-md-inline text-uppercase"  data-i18n="akros.running">Akros Running</span>
            </button>
              
        `;
    }
    else
    {
        html = /*html*/`
        
            <button id="btn-akros" class="btn btn-light btn-sm btn-active-color-primary btn-fixed-top" style="box-shadow: 2px 2px 4px 0px rgba(255,136,0,0.25) !important;-webkit-box-shadow: 2px 2px 4px 0px rgba(255,136,0,0.25) !important;-moz-box-shadow: 2px 2px 4px 0px rgba(255,136,0,0.25) !important;">
                <i class="bi bi-shield fs-3"></i>
                <span class="d-none d-md-inline text-uppercase" data-i18n="akros.ac">Anti-cheat</span>
            </button>
        
        `;
    }

    html = $(html);
    html.localize();
    $("#akros-modal").localize();
    $("#akros-modal-processing").localize();
    $(".btn-akros").html(html);
}

_handler.on("akros", (data) => {
    if(akrosFirstRender && data.event && akrosSocket.state > -1)
    {       
        console.log(data.event, $("#btn-akros").hasClass("akros-running"));
        if((data.event == 'init' && !$("#btn-akros").hasClass("akros-running")) || (data.event == 'close' && $("#btn-akros").hasClass("akros-running")))
        {
            renderAkrosBtn();
        }        
    }
});



/**
 * 
 * 
 *  APP ENGAGE
 * 
 * 
 */

$(document).ready(function(){
    $(document).on("click", "#kt_app_engage_toggle_on",async function() {
        $("#kt_app_engage").removeClass("app-engage-hide");
    });

    $(document).on("click", "#kt_app_engage_toggle_off",async function() {
        $("#kt_app_engage").addClass("app-engage-hide");
    });
});



/**
 * 
 * 
 *  GLOBAL CHAT
 *  
 * 
 */

let globalChatDrawer = null;
let isTransitioning = false;
let firstOpen = false;
let newMsgs = 0;

$(document).ready(function(){
    $(document).on("click", "#btn-send-global-chat",async function() {
        let message = $("#global-chat-input").val();
        message = message.trim();
        if(message.length)
        {
            sendGlobalChatMessage({content: message});
            $("#global-chat-input").val("");
        }
        else
        {
            $("#global-chat-input").focus();
        }
    });

    $(document).on("keypress", "#global-chat-input",async function(e) {
        
        if (e.keyCode == 27)
        {
            e.preventDefault();
        }

        if (e.keyCode == 13 && !e.shiftKey) {
            e.preventDefault();
            let message = $("#global-chat-input").val();
            message = message.trim();
            if(message.length)
            {
                sendGlobalChatMessage({content: message});
                $("#global-chat-input").val("");
            }
        }
        
    });

    $(document).on("click", ".app-global-chat",async function(e) {        

        if(isTransitioning) return;
        isTransitioning = true;
        animateCSS(".app-global-chat", 'fadeOut').then(() => {
            $(this).addClass("d-none");
        });
        $(".app-global-chat-window").removeClass("d-none");
        await animateCSS(".app-global-chat-window", 'slideInRight');
        //$("#global-chat-container").scrollTop($("#global-chat-container")[0].scrollHeight);
        $("#global-chat-input").focus();
        if(!firstOpen && globalChatStarted) 
        {
            firstOpen = true;
            $("#global-chat-container").scrollTop($("#global-chat-container")[0].scrollHeight);
            console.log("first open");
        }
        isTransitioning = false;
        
        $(".app-global-chat-new-incoming-msg").html(``).addClass("d-none");
    });

    $(document).on("click", ".app-global-chat-hide",async function(e) {
        if(isTransitioning) return;
        isTransitioning = true;
        animateCSS(".app-global-chat-window", 'slideOutRight').then(() => {
            $(".app-global-chat-window").addClass("d-none");
        });
        $(".app-global-chat").removeClass("d-none");
        await animateCSS(".app-global-chat", 'fadeIn');        
        isTransitioning = false;
    });

});

let isLoadInProgress = false;
let globalChatStarted = false;

const loadPreviousMessages = async () => {
    if(isLoadInProgress) return;
    isLoadInProgress = true;
    //let lastMsgId = $("#global-chat-container").children(":first-child").attr("_id");
    //let lastMsgId = $("#global-chat-container").children(":first-child").find(".global-multi-chat-content").find(".global-single-chat-content")[0].attr("_id");
    let lastMsgId = $("#global-chat-container").children(":first-child").find(".global-multi-chat-content").find(".global-single-chat-content").eq(0).attr("_id");
    let res = await KTAPI.getGlobalChatHistory({page:0,limit:10,lastMsgId});
    if(res.res.length)
    {
        await renderGlobalChats(res.res, true);
    }
    isLoadInProgress = false;
};

const offscreenSocket = (socket) => {
    socket.on("user-connected", async (data) => {
        //console.log(data); 
        if(data === undefined) return;
        if(data.data === undefined) return;
        renderUserConnected(data.data);
        
        $(`.online-badge[steamid="${data.data.steamid}"]`).removeClass("bg-gray-400").addClass("bg-success");
        //console.log("User connected: ", data.data.steamid, _user.me.steamid);
        if(data.data.steamid == _user.me.steamid)
        {
            _user.me.connected = true;
        }

        $(".app-global-chat-online-users").text(data.data.totalGuests + data.data.totalUsers);
    });

    socket.on("user-disconnected", async (data) => {
        
        if(data === undefined) return;
        if(data.data === undefined) return;
        $(".global-chat-contacts").find(`[steamid="${data.data.steamid}"]`).fadeOut(300, function() { $(this).remove(); });
        //console.log(data); 
        $(`.online-badge[steamid="${data.data.steamid}"]`).removeClass("bg-success").addClass("bg-gray-400");
        if(data.data.steamid == _user.me.steamid)
        {
            _user.me.connected = false;
        }

        $(".app-global-chat-online-users").text(data.data.totalGuests + data.data.totalUsers);
    });

    socket.on("global-chat-message", async (data) => {
        if(data === undefined) return;
        if(data.data === undefined) return;

        if($(".app-global-chat-window").hasClass("d-none"))
        {
            newMsgs++;
            if(newMsgs > 0)
            {
                $(".app-global-chat-new-incoming-msg").html(`<span class="badge badge-sm badge-light-success">+${newMsgs}</span>`).removeClass("d-none");
            }
        }

        await renderGlobalChats([data.data]);
    });
};

let lastViewScrollMsg = '';

const startGlobalChat = async () => {

    let wM = new WindowManager('.window', {
        headerSelector: '.custom-window-header',
        minimizeSelector: '.custom-window-minimize',
        restoreSelector: '.custom-window-restore',
        closeSelector: '.custom-window-close',
        minWidth: 250,
        maxWidth: 400,
        minHeight: 400,
        maxHeight: 800,
        defaultWidth: 350,
        defaultHeight: 700,
        defaultPosition: {bottom: 10, right: 10},
        onMinimize: function($element) {
            console.log("Ventana minimizada:", $element);
        },
        onRestore: function($element) {
            console.log("Ventana restaurada:", $element);
        },
        onClose: function($element) {
            console.log("Ventana cerrada:", $element);
        },
        onDrag: function($element) {
            console.log("Ventana arrastrada:", $element);
        },
        onResize: function($element) {
            console.log("Ventana redimensionada:", $element);
        }
    });

    //if(globalChatDrawer != null) globalChatDrawer.destroy();
    //globalChatDrawer = new KTDrawer($("#kt_global_chat")[0]);//, {name: "global", activate: true, overlay: true, width: "{default:'100%', 'md': '700px'}", direction: "end", close: "#global-chat-close", toggle: "#btn-global-chat"});

    $("#kt_global_chat").css("visibility", "visible");

    //let global_chat_contacts_body = new KTScroll($("#global_chat_contacts_body")[0]);

    //let global_chat_container = new KTScroll($("#global-chat-container")[0]);
   
    /*globalChatDrawer.on("kt.drawer.shown", function() {
        $("#global-chat-input").focus();
    });*/

    let res = await KTAPI.getUsersOnline();
    if(res.message == 'done')
    {
        $(".app-global-chat-online-users").text(res.totalGuests + res.totalUsers);
        if(res.users.length)
        {
            res.users.map(user => {
                renderUserConnected(user);
            });
        }        
    }

    res = await KTAPI.getGlobalChatHistory({limit:20,page:1});
    //renderGlobalChats(res.res.docs);
    await executeRenderGlobalChats(res);

   

    $("#global-chat-container").off("scroll").on("scroll", function() {
        
        
        if ($(this).scrollTop() === 0 && globalChatStarted) {
            
            //setTimeout(() => {
                lastViewScrollMsg = $("#global-chat-container").children(":first-child").find(".global-multi-chat-content").find(".global-single-chat-content").eq(0).attr("_id");
                loadPreviousMessages();
            //}, 3000);
        }
    });

    globalChatStarted = true;
    $("#global-chat-container").scrollTop($("#global-chat-container")[0].scrollHeight);
};

async function executeRenderGlobalChats(res) {
    await new Promise((resolve, reject) => {
        try {
            renderGlobalChats(res.res.docs);
            resolve();
        } catch (error) {
            reject(error);
        }
    });

    // Código que se ejecutará después de que renderGlobalChats haya terminado
    console.log("renderGlobalChats ha terminado de ejecutarse.");
    $("#global-chat-container").scrollTop($("#global-chat-container")[0].scrollHeight);
}

const renderGlobalChats = async (data, prepend = false) => {
    if(data === undefined) return;
    
    if(!prepend) data = data.reverse();

    if(data.length)
    {
       /* console.log(data.length + " messages");
        //let html = [];
        data.map(async chat => {
            //html.push(renderGlobalChat(chat));
            await renderGlobalChat(chat);
            if(!prepend) 
            {
                $("#global-chat-container").scrollTop($("#global-chat-container")[0].scrollHeight);
            }
            else
            {
                let elementPosition = $(`.global-single-chat-content[_id="${lastViewScrollMsg}"]`).offset().top;
                $("#global-chat-container").scrollTop(elementPosition);                
            }
        });
        //$("#global-chat-container").append(html);*/
        for( const chat of data)
        {
            await renderGlobalChat(chat, prepend);
            if(!prepend) 
            {
                $("#global-chat-container").scrollTop($("#global-chat-container")[0].scrollHeight);
            }
            else
            {
                let elementPosition = $(`.global-single-chat-content[_id="${lastViewScrollMsg}"]`).offset().top;
                $("#global-chat-container").scrollTop(elementPosition);                
            }
        }
    }

    async function renderGlobalChat(chat)
    {
        let myTail = `
        <span class="global-chat-tail" aria-hidden="true" style="position: absolute;top: 0;right: -10px;display: block;width: 18px;height: 21px;">
            <svg viewBox="0 0 18 21" height="21" width="18" preserveAspectRatio="xMidYMid meet" class="" version="1.1" x="0px" y="0px" enable-background="new 0 0 18 21">
                <title>tail</title>
                <path opacity="0.13" fill="rgba(0, 0, 0, 0)" d="M14.55,7.2L0,21.29V2.25h11.7C15.66,2.25,16.93,4.8,14.55,7.2z"></path>
                <path fill="#384a0f" d="M14.55,5.7L0,19.29V0h11.7C15.66,0,16.93,2.55,14.55,5.7z"></path>
            </svg>
        </span>

        `;
        let notMyTail = `
        <span class="global-chat-tail" aria-hidden="true" style="position: absolute;top: 0;left: -10px;display: block;width: 18px;height: 21px;">
            <svg viewBox="0 0 18 21" height="21" width="18" preserveAspectRatio="xMidYMid meet" class="" version="1.1" x="0px" y="0px" enable-background="new 0 0 18 21">
                <title>tail</title>
                <path opacity="0.13" fill="rgba(0, 0, 0, 0)" d="M3.45,7.2L18,21.29V2.25H6.3C2.34,2.25,1.07,4.8,3.45,7.2z"></path>
                <path fill="#2b2b2b" d="M3.45,5.7L18,19.29V0H6.3C2.34,0,1.07,2.55,3.45,5.7z"></path>
            </svg>
        </span>
        `;

        let body = `<div class="py-2 px-3 rounded ${chat.senderDetails.steamid == _user.me.steamid ? "bg-light-success" : "bg-light-dark"} text-start w-100 fw-normal position-relative" style="margin-bottom: 3px">
                        ${chat.senderDetails.steamid == _user.me.steamid ? myTail : notMyTail}
                        <div class="d-flex align-items-center mb-2 global-single-chat-header">
                            <a href="user/${chat.senderDetails.communityid}" data-navigo="" class="fs-7 fw-bold text-truncate text-nowrap text-gray-900">${chat.senderDetails.nickname}</a>
                        </div>
                        <div class="global-single-chat-content fs-7 fw-light" _id="${chat._id}">
                        </div>
                        <span class="text-gray-600 fw-bold fs-9 align-self-end position-absolute" data-i18n="example.date" data-i18n-options='{"timestamp":"${parseInt(chat.createdAt)+hostStampDif}"}' style="bottom:2px;right:6px;"></span>
                    </div>
                    `;
        body = $(body);
        body.find(".global-single-chat-content").text(chat.content);
        body.localize();

        const embeddedContent = await parseYouTubeLinks(body.find(".global-single-chat-content").html());
        body.find(".global-single-chat-content").html(embeddedContent);


        let lastElement = !prepend ? $("#global-chat-container").children(":last-child") : $("#global-chat-container").children(":first-child");
        if(lastElement.length && lastElement.attr("steamid") == chat.senderDetails.steamid)
        {
            
            if(!prepend)
                {
                    body.find(".global-single-chat-header").remove();
                    body.find(".global-chat-tail").remove();
                    lastElement.find(".global-multi-chat-content").append(body);
                }
            else
                {
                    lastElement.find(".global-multi-chat-content").children(":first-child").find(".global-single-chat-header").remove();
                    lastElement.find(".global-multi-chat-content").children(":first-child").find(".global-chat-tail").remove();
                    lastElement.find(".global-multi-chat-content").prepend(body);
                }
            return;
            
        }
        else
        {
            let html = /*html*/`
                <div class="d-flex position-relative mb-3 w-100 ${chat.senderDetails.steamid == _user.me.steamid ? "flex-row-reverse" : ""}" steamid="${chat.senderDetails.steamid}">
                    <div class="d-flex align-items-start ${chat.senderDetails.steamid == _user.me.steamid ? "ms-3" : "me-3"}">
                        <div class="symbol symbol-35px">
                            <img alt="Pic" src="${chat.senderDetails.avatar}">
                        </div>                    
                    </div>
                    <div class="d-flex flex-row-fluid flex-column align-items-start global-multi-chat-content">
                    </div>
                </div>            
            `;
            html = $(html);
            html.find(".global-multi-chat-content").append(body);

            if(!prepend)
                {$("#global-chat-container").append(html);}
            else
                {$("#global-chat-container").prepend(html);}
        }
                
        
        //return html;
    }    
};

async function parseYouTubeLinks(messageContent) {
    const youtubeRegex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const match = messageContent.match(youtubeRegex);

    
  
    if (match) {
      const videoId = match[1];
      let vid = await KTAPI.getYotubeVideoInfo({videoId});
      if(vid.message == 'error')    return messageContent;
      let params = vid.res.videoDetails;
      let imgSrc;
        for (let i = 4; i >= 0; i--) {
            if (params.thumbnails[i] !== undefined) {
                imgSrc = params.thumbnails[i].url;
                break;
            }
        }

        // Si no se encontró ninguna URL válida, puedes manejar el caso aquí
        if (!imgSrc) {
            console.error("No se encontró una URL válida en los thumbnails.");
        }
      const embedCode = `
        <!-- <div class="embed-responsive embed-responsive-16by9  ps-10 mb-4">
            <iframe width="0" height="0" src="https://www.youtube.com/embed/${videoId}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
        </div>-->

        <div class="over position-relative cursor-pointer bg-transparent w-100" videoid="${params.videoId}">
                    <img src="${imgSrc}" class="img-fluid w-100 h-auto" alt="${params.title}">
                    <div class="position-absolute top-50 start-50 w-80px h-80px" style="transform: translate(-50%, -50%);">
                        <div class="d-flex w-100 h-100 align-items-center justify-content-center bg-opacity-50 bg-light rounded">
                            <i class="bi bi-play-circle fs-4qx text-white"></i>
                            <span class="visually-hidden">Play video</span>
                        </div>
                    </div>
        </div>
        `;
      const embeddedMessage = messageContent.replace(youtubeRegex, embedCode);
  
      return embeddedMessage;
    }
  
    return messageContent;
  }

const renderUserConnected = (data) => {
    if($(".global-chat-contacts").find(`[steamid="${data.steamid}"]`).length) 
    {
        let $this = $(".global-chat-contacts").find(`[steamid="${data.steamid}"]`);
        $this.attr("socketid", data._id);
        $this.find(".contact-avatar").attr("src", data.avatar);
        $this.find(".fnickname").text(data.nickname).attr("href", `user/${data.communityid}`);

    }
    else
    {
        let html = `
            <div class="d-flex flex-stack py-2" steamid="${data.steamid}" socketid="${data._id}" style="display:none;">
                <!--begin::Details-->
                <div class="d-flex align-items-center">
                    <!--begin::Avatar-->
                    <div class="symbol symbol-40px">
                        <img class="contact-avatar" alt="Pic" src="${data.avatar}">
                        <div class="symbol-badge online-badge bg-success start-100 top-100 border-1 border-black h-10px w-10px ms-n2 mt-n2"></div>
                    </div>
                    <!--end::Avatar-->
                    <!--begin::Details-->
                    <div class="ms-5 mw-150px text-truncate text-nowrap">
                        <a href="user/${data.communityid}" data-navigo class="fs-7 fw-normal text-gray-900 mb-2 fnickname"></a>
                        <!--<div class="fw-bold text-muted fs-7">${data.steamid}</div>-->
                        <div><a href="https://steamcommunity.com/profiles/${data.communityid}/" target="_blank" class="fw-bold text-muted fs-7">${data.steamid}</a></div>
                    </div>
                    <!--end::Details-->
                </div>
                <!--end::Details-->            
            </div>
        `;

        html = $(html);
        html.find(".fnickname").text(data.nickname);

        $(".global-chat-contacts").append(html);
        router.updatePageLinks();
        $(".global-chat-contacts").find(`[steamid="${data.steamid}"]`).fadeIn(300);
    }
};

const sendGlobalChatMessage = async (data) => {
    
    if(ioSocket.socket == null) return;
    if(ioSocket.connected == false) return;
    ioSocket.socket.emit("global-chat-message", data);

};


/**
 * 
 * 
 * PARTY
 * 
 * 
 */




/**
 * 
 * 
 *  TOASTER
 * 
 * 
 */


export {offscreenSocket};
export default offscreen;
export {errorMsg};
export {msgDialog, welcomeDialog};